/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthForgotPasswordRequest, AuthForgotPasswordResponse } from '../types/AuthForgotPassword'

/**
 * POST /auth/forgot-password
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::forgotPassword
 */
export async function authForgotPassword(
	data: AuthForgotPasswordRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthForgotPasswordResponse>> {
	return axiosInstance.post('/auth/forgot-password', data, config)
}
